export interface IBoxConstraints {
  maxWidth: number;
  maxHeight: number;
}
export enum WhichPlate {
  'left' = 'Left',
  'right' = 'Right',
  'both' = 'Both',
}
export interface IPoint {
  x: number;
  y: number;
}
